
import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import '../../scss/Navmenudetail.scss'
import { FaLock, FaMinus } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";


export default function ReviewQuestion(props) {
    const { visible, onClose, type, socauhoi, arrIdQuestion, arrcautraloi, indexDF, openMenuLeft, onSubmit } = props;
    var arrBookMark = localStorage.getItem('arrBookMark');
    const [arrBook, setArrBook] = useState(arrBookMark ? JSON.parse(arrBookMark) : []);
    const [arrBookNew, setarrBookNew] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const renderTitle = () => {
        if (type == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (type == "NGHE") {
            return "Listening";
        }
        else if (type == "DOC") {
            return "Reading";
        }
        else if (type == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }
    useEffect(() => {
        var arrBookMark = localStorage.getItem('arrBookMark');
        const parsed = arrBookMark ? JSON.parse(arrBookMark) : [];
        setArrBook(parsed);

        let arr = []
        setarrBookNew(arr);
    }, [visible, arrIdQuestion]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="card">
            <Dialog
                header="Question Review"
                visible={visible}
                position='center'
                style={{
                    width: isMobile ? '90vw' : '480px'
                }}
                onHide={() => onClose()}
                draggable={false}
                resizable={false}
            >
                <div style={{margin:'0px 20px'}}>
                    <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
                        Please review the following questions
                    </div>

                    <div
                        className="mt-4"
                        style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: 10,
                            marginTop: 14,
                            overflow: 'hidden',
                            background: '#f9fafb'
                        }}
                    >
                        <div
                            className="d-flex"
                            style={{
                                padding: '10px 12px',
                                borderBottom: '1px solid #e5e7eb',
                                background: '#f3f4f6'
                            }}
                        >
                            <div style={{ padding: '2px 4px', width: '85%' }}>
                                <div style={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
                                    {renderTitle()}
                                </div>
                                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                                    {socauhoi} Questions
                                </div>
                            </div>
                            <div className="d-flex justify-content-center" style={{ width: '15%', alignItems: 'center' }}>
                                <div style={{ backgroundColor: '#e5e7ff', padding: '6px', borderRadius: 6 }}>
                                    {
                                        arrIdQuestion.length === 0
                                            ? <FaLock size={14} />
                                            : <FaMinus size={14} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                padding: '6px 10px 10px 10px',
                                maxHeight: isMobile ? '55vh' : '30vh',
                                overflowY: 'auto',
                                background: '#f9fafb'
                            }}
                        >
                            {arrIdQuestion && arrIdQuestion.map((item, index) => {
                                let isBook = false;
                                if (typeof item === 'string') {
                                    isBook = Array.isArray(arrBook) && arrBook.indexOf(item) > -1;
                                } else if (Array.isArray(arrBook)) {
                                    for (let i = 0; i < arrBook.length; i++) {
                                        if (typeof arrBook[i] === 'object' && arrBook[i].idnhom === item.idnhom) {
                                            isBook = true;
                                            break;
                                        }
                                    }
                                }

                                const isCurrentQuestion = indexDF === index;
                                const isSeen = index < indexDF; // Đã xem qua
                                const isUnseen = index > indexDF; // Chưa xem
                                
                                // Kiểm tra xem câu hỏi đã được trả lời chưa
                                const answerValue = arrcautraloi && arrcautraloi[index];
                                const isAttempted = answerValue !== undefined && 
                                    answerValue !== null && 
                                    answerValue !== "" && 
                                    answerValue !== "0" && 
                                    answerValue !== 0 &&
                                    !(Array.isArray(answerValue) && answerValue.length === 0) &&
                                    !(typeof answerValue === 'object' && Object.keys(answerValue).length === 0);

                                // Xác định trạng thái xem
                                let viewStatus = "Unseen";
                                if (isCurrentQuestion) {
                                    viewStatus = "Current";
                                } else if (isSeen) {
                                    viewStatus = "Seen";
                                } else if (isUnseen) {
                                    viewStatus = "Unseen";
                                }

                                return (
                                    <div
                                        onClick={() => openMenuLeft(item, index)}
                                        className="mt-2 cursor-pointer"
                                        key={index}
                                        style={{
                                            padding: '6px 10px',
                                            backgroundColor: isCurrentQuestion ? '#e5e7eb' : '#f9fafb',
                                            borderRadius: 6,
                                            border: '1px solid #e5e7eb'
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <strong style={{ fontSize: 13 }}>
                                                {index < 9 ? ("0" + (index + 1)) : (index + 1)}
                                            </strong>
                                            {isBook && <FaBookmark size={16} color="#f59e0b" />}
                                        </div>
                                        <div className="d-flex justify-content-between" style={{ marginTop: 2 }}>
                                            <div style={{ fontSize: 11, color: '#6b7280' }}>
                                                {viewStatus}
                                            </div>
                                            <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                                {isAttempted ? "Attempted" : "Not Attempted"}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                    </div>

                    {/* <div style={{ marginTop: 18 }}>
                        <Button
                            label="Review Questions"
                            style={{
                                width: '100%',
                                background: '#23085a',
                                borderColor: '#23085a',
                                boxShadow: '0 8px 18px rgba(35, 8, 90, 0.22)',
                                padding: '0.6rem 0.75rem',
                                fontSize: 14
                            }}
                            onClick={() => onClose()}
                        />
                    </div> */}
                    {onSubmit && (
                        <div style={{ marginTop: 10 , marginBottom:'20px'}}>
                            <Button
                                label="Submit"
                                className="p-button-outlined"
                                style={{
                                    color: '#fff',
                                    width: '100%',
                                    background: '#23085a',
                                    borderColor: '#23085a',
                                    boxShadow: '0 8px 18px rgba(35, 8, 90, 0.22)',
                                    padding: '0.6rem 0.75rem',
                                    fontSize: 14
                                }}
                                onClick={() => {
                                    onSubmit();
                                    onClose();
                                }}
                            />
                        </div>
                    )}
                </div>
            </Dialog>
        </div>
    )
}
